import React, { useEffect } from "react";

interface DynamicTabProps {
    title: string;
    favicon: string;
    children: React.ReactNode;
}

const DynamicTab: React.FC<DynamicTabProps> = ({ title, favicon, children }) => {
    useEffect(() => {
        // Update tab name
        document.title = title;

        // Update favicon
        const existingFavicon = document.getElementById("favicon") as HTMLLinkElement | null;

        if (existingFavicon) {
            existingFavicon.href = favicon;
        } else {
            const link = document.createElement("link");
            link.id = "favicon";
            link.rel = "icon";
            link.type = "image/png";
            link.href = favicon;
            document.head.appendChild(link);
        }
    }, [title, favicon]);

    return <>{children}</>;
};

export default DynamicTab;